import classNames from 'classnames';

import styles from './styles.module.scss';

const UnreadMessagesCounter = ({ counter = null }) => {
    const isBigNumber = counter > 99 || false;
    return <span className={classNames(styles.unread, { [styles.smallFont]: isBigNumber })}>{isBigNumber ? '99+' : counter}</span>;
};

export default UnreadMessagesCounter;
